import Loactions from "../../../components/Locations";

const LocationsPage = () => {
    return <Loactions />
}
export default LocationsPage;
